import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';

import AppRoutes from '../../config/AppRoutes';
import CustomButton from '../Button/CustomButton';
import CustomCard from '../CustomCard';
import CardBody from '../CustomCard/CardBody';
import CardHeader from '../CustomCard/CardHeader';
import Header from '../Header';
import LoaderWrapper from '../LoaderWrapper';
import Question from '../QuestionBank/Question';
import ReverseTimer from '../Timer/ReverseTimer';
import {
  addStrikeThrough,
  flagUnFlagSelectedQuestion,
  getMockDetailsById,
  getStrikedText,
  getUserStatsByTestId,
  mockQuestions,
  saveMockUserChoice,
  setCBTScore,
  setTestStatusByTestId,
  setUserChoice,
  updateUserTimer,
} from '../services';
import Flagged from './Flagged';
import ReviewSectionButton from './ReviewSectionButton';
import SectionReview from './SectionReview';
import SidebarIndex from './SidebarIndex';

import CBTFinishTest from '../../Common/CBTFinishTest';
import CBTFlagged from '../../Common/CBTFlagged';
import CBTNonAttempted from '../../Common/CBTNonAttempted';

export default class CBTQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionData: [],
      strikeThroughArr: [],
      flaggedQuesObject: {},
      attemptedQuesObject: {},
      showSectionReview: false,
      isLoading: true,
      title: '',
      userTimeValue: props.params.timer,
      showFinishTestPopup: false,
      showNonAttemptedPopup: false,
      showFlaggedPopup: false,
      showPopover: false,
    };
    this.slider = '';
  }

  static contextTypes = { router: React.PropTypes.object };

  componentDidMount() {
    window.scrollTo(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    const {
      chapterId,
      params: { mockId, testId },
    } = this.props;
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapterId,
      mock_id: isNaN(mockId) ? 1 : parseInt(mockId, 10),
      test_id: isNaN(testId) ? 1 : parseInt(testId, 10),
    };

    this.fetchQuestionByMock(data);
    this.fetchUserRecordByTestId(data);
    this.getTitle(data);
  }

  fetchQuestionByMock = async data => {
    const response = await mockQuestions(data);
    if (response.success) {
      this.setState({ questionData: response.question });
      const {
        location: { pathname },
        params: { offset },
      } = this.props;
      if (pathname.includes(':questionId'))
        this.context.router.replace({
          pathname: pathname.replace(':questionId', response.question[offset].id),
          state: {},
        });

      this.strikeThroughChoices(response.question[offset].id);
    }
    this.setState({ isLoading: false });
  };

  strikeThroughChoices = async questionId => {
    const { testId, mockId } = this.props.params;
    const result = await getStrikedText({
      questionId,
      testId,
      mockId,
    });
    let strikeThroughArr = [];
    if (result.success) {
      const { choiceArray } = result.data;
      if (choiceArray) {
        strikeThroughArr = JSON.parse(choiceArray);
      }
    }
    this.setState({ strikeThroughArr });
  };
  getTitle = async data => {
    const response = await getMockDetailsById({ mockId: data.mock_id });
    if (response.success) {
      this.setState({ title: response.mockData.mock_exam });
    }
  };
  fetchUserRecordByTestId = async data => {
    try {
      const response = await getUserStatsByTestId(data);
      if (response.success) {
        const {
          questions = {},
          flagged_questions = {},
          user_time_value: userTimeValue,
        } = response.userStatsData;
        const { questionId } = this.props.params;

        const attemptedQuesObjectFromRes = questions ? JSON.parse(questions) : {};
        if (parseInt(userTimeValue, 10) !== 0) {
          this.setState({
            userTimeValue,
            attemptedQuesObject: attemptedQuesObjectFromRes,
            selectedChoice: attemptedQuesObjectFromRes[questionId] || '',
            flaggedQuesObject: flagged_questions ? JSON.parse(flagged_questions) : {},
          });
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.trace(error);
    }
  };

  getQuestionIDfromOffset = (offset = 0) => {
    const { questionData } = this.state;
    let parsedOffset = parseInt(offset, 10);
    if (isNaN(parsedOffset)) parsedOffset = 0;
    return questionData[offset].id;
  };

  getQuestionDetailsfromOffset = (offset = 0) => {
    const { questionData } = this.state;
    let parsedOffset = parseInt(offset, 10);
    if (isNaN(parsedOffset)) parsedOffset = 0;
    return questionData[offset];
  };

  setAnswer = async answer => {
    const { attemptedQuesObject } = this.state;
    const { offset, testId, mockId } = this.props.params;
    const questionDetails = this.getQuestionDetailsfromOffset(offset) || {};
    const [userAnser] = answer;
    attemptedQuesObject[questionDetails.id] = userAnser;

    this.setState({
      selectedChoice: answer[0],
      attemptedQuesObject,
    });
    // Calling API to set answer
    await saveMockUserChoice({
      choice: answer[0],
      test_id: testId,
      mock_id: mockId,
      index: offset,
      question_id: questionDetails.id,
    });
    // Insert data into Database
    setUserChoice({
      mock_id: mockId,
      question_id: questionDetails.id,
      test_id: testId,
      chapter_id: questionDetails.chapter_id,
      answer: questionDetails.correct_choice === answer[0] ? 'correct' : 'incorrect',
    });
  };

  strikeText = (event, value) => {
    event.preventDefault();
    const [choice] = value;
    const { strikeThroughArr } = this.state;
    this.setState({ strikeThroughArr: this.toggleArray(strikeThroughArr, choice) });
    const { questionId, testId, mockId } = this.props.params;

    addStrikeThrough({
      mockId,
      questionId,
      testId,
      choice,
    });
  };

  toggleArray = (array, value) => {
    const choiceIndex = array.findIndex(element => element === value);
    if (choiceIndex === -1) {
      array.push(value);
    } else {
      array.splice(choiceIndex, 1);
    }
    return array;
  };

  onFlagClick = offset => {
    const { flaggedQuesObject } = this.state;
    const { mockId, testId } = this.props.params;
    const questionId = this.getQuestionIDfromOffset(offset);
    if (flaggedQuesObject[questionId]) {
      delete flaggedQuesObject[questionId];
    } else {
      flaggedQuesObject[questionId] = 'flagged';
    }
    flagUnFlagSelectedQuestion({
      flaggedQuestions: flaggedQuesObject,
      testId,
      mockId,
    });

    this.setState({ flaggedQuesObject });
  };

  changeQuestionByIndex = inputIndex => {
    let index = inputIndex;
    if (isNaN(index)) index = 0;
    const { mockId, testId, isNegative, timerStart, timer } = this.props.params;
    const { attemptedQuesObject } = this.state;
    const questionId = this.getQuestionIDfromOffset(index);

    this.slider.slickGoTo(index);
    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_QUESTIONS.replace(':offset', index)
        .replace(':mockId', mockId)
        .replace(':questionId', questionId)
        .replace(':testId', testId)
        .replace(':isNegative', isNegative)
        .replace(':timerStart', timerStart)
        .replace(':timer', timer),
    });
    this.strikeThroughChoices(questionId);

    this.setState({ selectedChoice: attemptedQuesObject[questionId] || '' });
  };

  onClickPreviousButton = offset => {
    this.changeQuestionByIndex(offset - 1);
  };
  onClickNextButton = offset => {
    this.changeQuestionByIndex(offset + 1);
  };

  checkFlaggedQuestion = () => {
    const { flaggedQuesObject } = this.state;
    if (Object.keys(flaggedQuesObject).length) {
      this.setState({ showFlaggedPopup: true });
      return;
    }
    this.checkAllQuestionAttempted();
  };

  checkAllQuestionAttempted = () => {
    const { attemptedQuesObject, questionData } = this.state;
    const attemptedQuesLength = Object.keys(attemptedQuesObject).length;

    if (!attemptedQuesLength || attemptedQuesLength !== questionData.length) {
      this.setState({ showNonAttemptedPopup: true });
      return;
    }
    this.setState({ showFinishTestPopup: true });
  };

  navigateToFinishPage = async () => {
    const { mockId, testId, offset, timer } = this.props.params;
    const questionId = this.getQuestionIDfromOffset(offset);

    try {
      await Promise.all([
        setTestStatusByTestId({
          id: testId,
          mock_id: mockId,
        }),
        setCBTScore({
          testId,
          mockId,
        }),
      ]);
    } catch (errors) {
      // Handle errors for both operations
      errors.forEach(error => {
        // eslint-disable-next-line no-console
        console.trace(error);
      });
    }

    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_FINISH_PAGE.replace(':offset', offset)
        .replace(':mockId', mockId)
        .replace(':questionId', questionId)
        .replace(':timer', timer)
        .replace(':testId', testId),
    });
  };
  handleCallback = childData => {
    this.slider = childData.slider;
  };

  onStopTimer = () => {
    this.setTimerParam(false);
  };

  onStartTimer = () => {
    this.setTimerParam(true);
  };

  setTimerParam = timerStart => {
    const { mockId, testId, questionId, isNegative, timer, offset } = this.props.params;

    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_QUESTIONS.replace(':offset', offset)
        .replace(':mockId', mockId)
        .replace(':questionId', questionId)
        .replace(':testId', testId)
        .replace(':isNegative', isNegative)
        .replace(':timerStart', timerStart)
        .replace(':timer', timer),
    });
  };

  render() {
    const {
      questionData,
      selectedChoice,
      strikeThroughArr,
      attemptedQuesObject,
      showSectionReview,
      flaggedQuesObject,
      isLoading,
      title,
      userTimeValue,
      showFinishTestPopup,
      showNonAttemptedPopup,
      showFlaggedPopup,
    } = this.state;
    let { offset = 0 } = this.props.params;
    const { mockId, testId, timer, isNegative, timerStart } = this.props.params;
    offset = parseInt(offset, 10);
    if (isNaN(offset)) offset = 0;

    let questionObject = {};
    try {
      if (questionData.length) {
        questionObject = questionData[offset];
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return (
      <LoaderWrapper isLoading={isLoading}>
        <div>
          <div className='animated fadeIn'>
            <Header title={title}>
              <CustomButton onClick={this.checkFlaggedQuestion}>Finish Test</CustomButton>
            </Header>
            <div className='d-flex font-16px'>
              <SidebarIndex
                itemArray={questionData}
                currentIndex={offset}
                slidesToShow={10}
                onClick={this.changeQuestionByIndex}
                initialSlide={offset}
                flaggedQuesObject={flaggedQuesObject}
                attemptedQuesObject={attemptedQuesObject}
                parentCallback={this.handleCallback}
              />
              <div className='ques-detail-wrapper'>
                <CustomCard className='w-100'>
                  <CardHeader
                    headerImage='/img/question_bank/question_icon_blue.svg'
                    headingText={`Q.${parseInt(offset, 10) + 1}`}
                    // headerClassName='pl-0'
                  />
                  <CardBody>
                    <Row>
                      <Col md={9} xs={12}>
                        {questionData.length && (
                          <Question
                            {...questionObject}
                            setAnswer={this.setAnswer}
                            selectedChoice={selectedChoice}
                            selectedChoiceClassName='border-yellow'
                            strikeText={this.strikeText}
                            strikeThroughArr={strikeThroughArr}
                            params={this.props.params}
                            shouldHighLight={true}
                          />
                        )}
                      </Col>
                      <Col md={3} xs={12}>
                        <ReverseTimer
                          intialTimerValue={userTimeValue}
                          apiCall={data =>
                            updateUserTimer({
                              mock_id: mockId,
                              isNegative,
                              testId,
                              timer,
                              id: testId,
                              ...data,
                            })
                          }
                          stopTimerOnMount={timerStart === 'false'}
                          onStopTimer={() => this.setTimerParam(false)}
                          onStartTimer={() => this.setTimerParam(true)}
                        />
                      </Col>
                      <Col md={3} xs={12} className='mt-2'>
                        <ReviewSectionButton
                          onClick={() => {
                            this.setState({ showSectionReview: true });
                          }}
                        />
                      </Col>
                      <Col md={9} xs={12} className='text-right mt-2'>
                        <div className='d-flex justify-content-end'>
                          <Flagged
                            className='mr-1'
                            flaggedQuestion={
                              questionData.length && flaggedQuesObject[questionData[offset].id]
                            }
                            onClick={() => this.onFlagClick(offset)}
                          />
                          <CustomButton
                            className='mid-btn'
                            onClick={() => this.onClickPreviousButton(parseInt(offset, 10))}
                            disabled={parseInt(offset, 10) === 0}
                          >
                            <i className='fa fa-angle-left' /> <span>Back</span>
                          </CustomButton>
                          <CustomButton
                            className='mid-btn'
                            onClick={() => this.onClickNextButton(parseInt(offset, 10))}
                            disabled={parseInt(offset, 10) === questionData.length - 1}
                          >
                            <span>Next</span> <i className='fa fa-angle-right' />
                          </CustomButton>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </CustomCard>
              </div>
            </div>
          </div>
          <SectionReview
            dataList={questionData}
            attemptedQuesObject={attemptedQuesObject}
            showSectionReview={showSectionReview}
            flaggedQuesObject={flaggedQuesObject}
            changeQuestion={this.changeQuestionByIndex}
            onClick={() => {
              this.setState({ showSectionReview: false });
            }}
          />
          {/* ======= Model Popups ============ */}
          <CBTFinishTest
            showFinishTestPopup={showFinishTestPopup}
            submitTest={this.navigateToFinishPage}
            handleClose={() => this.setState({ showFinishTestPopup: false })}
          />
          <CBTNonAttempted
            showFinishTestPopup={showNonAttemptedPopup}
            submitTest={() =>
              this.setState({
                showFinishTestPopup: true,
                showNonAttemptedPopup: false,
              })
            }
            handleClose={() => this.setState({ showNonAttemptedPopup: false })}
          />
          <CBTFlagged
            showFinishTestPopup={showFlaggedPopup}
            submitTest={() => {
              this.setState({ showFlaggedPopup: false });
              this.checkAllQuestionAttempted();
            }}
            handleClose={() => this.setState({ showFlaggedPopup: false })}
          />
        </div>
      </LoaderWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/CBTQuestion.jsx